import { Link } from 'react-router-dom';
import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useCurrentSalesOrder } from '@/providers/SalesOrderProvider';
import { useInvoiceTasks } from '@/hooks/api/1800_invoice_tasks';
import { Fragment } from 'react';
import { MotionDiv } from '@/components/element/MotionDiv';

export const InvoiceTasks = () => {
  const { _w_, _t_ } = useCurrentTeamMember();
  const { _so_ } = useCurrentSalesOrder();
  const { data: tasks } = useInvoiceTasks({
    identifier: _w_!.identifier,
    sales_order_id: _so_!.id,
    archived: true,
    page: 1,
    per: 1000,
  });

  return (
    <MotionDiv className="card mb-4">
      <div className="card-header d-flex align-items-center justify-content-between">
        <div>
          <h6 className="mb-0">請求タスク一覧</h6>
        </div>
        {['contracting', 'completed'].includes(_so_ ? _so_.team_sales_order_phase.name : '') && (
          <Link
            to={`/w/${_w_!.identifier}/teams/${_t_!.id}/sales_orders/${_so_!.id}/invoice_tasks/new`}
            className="btn bg-gradient-primary btn-icon flex-shrink-0"
          >
            <i className="fas fa-plus"></i>新規タスク作成
          </Link>
        )}
      </div>
      <div className="card-body pt-0">
        {tasks?.invoice_tasks.map((d, i) => (
          <Fragment key={`it-${d.id}`}>
            {i != 0 && <hr className="horizontal dark" />}

            <Link
              to={`/w/${_w_!.identifier}/teams/${_t_!.id}/sales_orders/${_so_!.id}/invoice_tasks/${d.id}`}
              className="d-flex align-items-center justify-content-between"
            >
              <div className="d-flex align-items-center">
                <div className="icon icon-sm bg-dark d-flex border-radius-md align-items-center justify-content-center flex-shrink-0">
                  <i className="fas fa-receipt text-white"></i>
                </div>
                <div className="ms-2">
                  <div className="font-weight-bold px-0 text-sm text-dark mb-1">{d.name}</div>
                  <div className="text-muted font-weight-bold text-xs">
                    {d.invoice_task_phase.label}, ¥
                    {d.invoice_task_phase.name == 'preparing'
                      ? d.billing_schedule_detail.amount.toLocaleString()
                      : d.billing_amount?.toLocaleString()}
                  </div>
                </div>
              </div>
              <i className="fas fa-angle-right text-muted opacity-3 flex-shrink-0 ms-2"></i>
            </Link>
          </Fragment>
        ))}
      </div>
    </MotionDiv>
  );
};
